module.exports = __webpack_public_path__ + "static/media/comment-alt-medical.0ee20533.svg";